(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      this.querySelector('[data-facets-open]')?.addEventListener('click', () => this.toggle(true));
      this.querySelectorAll('[data-facets-close]').forEach((b) => b.addEventListener('click', () => this.toggle(false)));
      this.form.addEventListener('input', () => this.debouncedSubmit());
      this.form.addEventListener('change', () => this.debouncedSubmit());
      this._t = null;
    }
    toggle(open) { this.toggleAttribute('data-open', open); document.documentElement.style.overflow = open ? 'hidden' : ''; }
    debouncedSubmit() { clearTimeout(this._t); this._t = setTimeout(() => this.submit(), 450); }
    async submit() {
      const params = new URLSearchParams(new FormData(this.form));
      // strip empty values
      for (const [k, v] of [...params]) if (!v) params.delete(k);
      const url = `${window.location.pathname}?${params}`;
      try {
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newResults = doc.querySelector('[data-product-grid-container]');
        const cur = document.querySelector('[data-product-grid-container]');
        if (newResults && cur) cur.innerHTML = newResults.innerHTML;
        const newFacets = doc.querySelector('[data-facets]');
        if (newFacets) {
          const panel = this.querySelector('[data-facets-panel]');
          const fresh = newFacets.querySelector('[data-facets-panel]');
          // keep panel open state; only refresh counts
          this.querySelector('[data-facets-count]').textContent = newFacets.querySelector('[data-facets-count]').textContent;
        }
        history.replaceState({}, '', url);
      } catch (e) { console.error('Filter failed', e); this.form.submit(); }
    }
  }
  customElements.define('facet-filters', FacetFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('.product-media__item');
      this.thumbs = this.querySelectorAll('[data-media-target]');
      this.lightbox = this.querySelector('.product-media__lightbox');
      this.lightboxImage = this.querySelector('.product-media__lightbox-image');

      this.thumbs.forEach((t) =>
        t.addEventListener('click', () => this.show(t.dataset.mediaTarget))
      );
      document.addEventListener('variant:media', (e) => this.show(e.detail.mediaId));

      this.querySelector('.product-media__stage')?.addEventListener('click', (e) => {
        const img = e.target.closest('.product-media__image');
        if (!img || !this.lightbox) return;
        this.lightboxImage.src = img.currentSrc || img.src;
        this.lightboxImage.alt = img.alt;
        this.lightbox.showModal();
      });

      this.querySelector('.product-media__lightbox-close')?.addEventListener('click', () => {
        this.lightbox?.close();
      });
      this.lightbox?.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.lightbox.close();
      });
    }
    show(id) {
      id = String(id);
      this.items.forEach((item) => {
        const match = item.dataset.mediaId === id;
        item.hidden = !match;
        item.classList.toggle('is-active', match);
      });
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaTarget === id));
    }
  }
  customElements.define('media-gallery', MediaGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quote-modal"] && !Shopify.designMode) return;
  try {
    class QuoteModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.quote-modal__dialog');
      if (!this.dialog) return;

      this.querySelector('[data-quote-open]')?.addEventListener('click', () => this.open());
      this.querySelector('[data-quote-close]')?.addEventListener('click', () => this.dialog.close());

      // Panel dışına tıklayınca kapansın
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });

      // Varyant seçimi değişince gizli alanlar güncellensin
      document.addEventListener('variant:change', (e) => this.syncVariant(e.detail?.variant));

      // Gönderim başarılıysa pencere açık gelsin ki kullanıcı onayı görsün
      if (this.querySelector('.quote-modal__success')) this.open();
    }

    open() {
      this.dialog.showModal();
      this.dialog.querySelector('input:not([type=hidden])')?.focus();
    }

    syncVariant(variant) {
      if (!variant) return;
      const set = (sel, val) => {
        const el = this.querySelector(sel);
        if (el) el.value = val ?? '';
      };
      set('[data-quote-variant-title]', variant.title);
      set('[data-quote-variant-id]', variant.id);
      set('[data-quote-variant-sku]', variant.sku);
      const label = this.querySelector('[data-quote-variant-label]');
      if (label) label.textContent = variant.title || '';
    }
  }
  customElements.define('quote-modal', QuoteModal);
  } catch(e) { console.error(e); }
})();

})();
